import { css } from "@emotion/react";

const AVATAR_RADIUS = "50%";

export const teamMembersAvatar = css`
  position: relative;
  text-align: center;
  margin: 0 auto;

  @media only screen and (max-width: 64em) {
    width: 300px;
    height: auto;
  }

  &:hover {
    &:before {
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.5);
    }

    span {
      left: 0;
      color: rgba(255, 255, 255, 1);
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: none;
    border-radius: 50%;
    transition: all 0.3s linear;
    -webkit-transition: all 0.3s linear;
    -moz-transition: all 0.3s linear;
  }
`;

export const avatarImage = css`
  /* Need to hard code image size so they're all the same */
  width: 300px;
  height: 300px;
  object-fit: cover;
  border-radius: ${AVATAR_RADIUS};
`;

export const icon = css`
  font-size: 270px;
  color: #555;
  border-radius: ${AVATAR_RADIUS};

  @media only screen and (min-width: 40.063em) and (max-width: 64em) {
    font-size: 298px;
  }
`;
